// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material'
import React from 'react'
import { Mutation, Query } from 'react-apollo'
import Loader from '../../../../../common/loader/Loader'
import Select from '../../../../../common/select/Select'
import { i18n } from '../../../../index'
import { fetchLinkTags } from '../../../guidelinesAndLinks/components/LinkTags/queries'
import { createIntroductionLink, fetchAokIntroductionLinks, fetchIntroductionLinks } from '../../queries'
import css from './CreationDialog.css'

const updateCacheOnCreate =
  (companyId) =>
  (cache, { data: { createIntroductionLink } }) => {
    const query = companyId ? fetchAokIntroductionLinks : fetchIntroductionLinks
    const variables = companyId
      ? {
          companyId: companyId,
        }
      : {}
    const fieldName = companyId ? 'aokIntroductionLinks' : 'introductionLinks'
    const data = cache.readQuery({
      query: query,
      variables: variables,
    })
    cache.writeQuery({
      query: query,
      variables,
      data: {
        [fieldName]: [...data[fieldName], createIntroductionLink],
      },
    })
  }

class CreationDialog extends React.Component {
  constructor() {
    super()
    this.state = {
      fileName: '',
      href: '',
      selectedLinkTag: '',
    }
  }

  onCancel = () => {
    this.setState({
      fileName: '',
      href: '',
      selectedLinkTag: '',
    })
    this.props.close()
  }
  onSubmit = (e, onMutate) => {
    const { companyId } = this.props
    e.preventDefault()
    const { fileName, href, selectedLinkTag } = this.state
    onMutate({
      variables: {
        fileName,
        href,
        companyId,
        linkTagId: selectedLinkTag,
      },
      update: updateCacheOnCreate(companyId),
    })
    this.props.close()
    this.setState({
      fileName: '',
      href: '',
      selectedLinkTag: '',
    })
  }

  onLinkTagSelected = (linkTagOption) => {
    this.setState({
      ...this.state,
      selectedLinkTag: linkTagOption.value,
    })
  }

  render() {
    const { isOpen } = this.props
    const { fileName, href, selectedLinkTag } = this.state
    return (
      <Dialog open={isOpen} onBackdropClick={this.onCancel}>
        <DialogTitle>{i18n.t('admin.introduction.creationDialogTitle')}</DialogTitle>

        <DialogContent>
          <Query query={fetchLinkTags}>
            {({ loading, data }) => (
              <Loader loading={loading}>
                <Mutation mutation={createIntroductionLink}>
                  {(onMutate) => (
                    <form onSubmit={(e) => this.onSubmit(e, onMutate)}>
                      <TextField
                        autoFocus
                        required
                        fullWidth
                        label={i18n.t('admin.introduction.fileName')}
                        placeholder={i18n.t('admin.introduction.fileNamePlaceholder')}
                        className={css.input}
                        value={fileName}
                        onChange={(e) =>
                          this.setState({
                            fileName: e.target.value,
                          })
                        }
                      />

                      <TextField
                        required
                        fullWidth
                        label={i18n.t('admin.introduction.link')}
                        placeholder={i18n.t('admin.introduction.linkPlaceholder')}
                        className={css.input}
                        value={href}
                        onChange={(e) =>
                          this.setState({
                            href: e.target.value,
                          })
                        }
                      />

                      <Select
                        onChange={this.onLinkTagSelected}
                        value={selectedLinkTag}
                        options={data?.linkTags?.map((linkTag) => ({ label: linkTag.name, value: linkTag.id })) ?? []}
                      />

                      <DialogActions>
                        <Button type='button' onClick={this.onCancel}>
                          {i18n.t('buttons.cancel')}
                        </Button>
                        <Button type={'submit'} color={'primary'}>
                          {i18n.t('buttons.save')}
                        </Button>
                      </DialogActions>
                    </form>
                  )}
                </Mutation>
              </Loader>
            )}
          </Query>
        </DialogContent>
      </Dialog>
    )
  }
}

export default CreationDialog
